import { getSelectedLanguage } from "../../aframe/utils/local-storage.utils";
import { Endpoints } from "../../endpoints";

export const getHelpCenterText = async () => {
  const x = await document
    .querySelector("a-scene")
    .systems.data.fetch(Endpoints.helpCenterPage());

  const lang = getSelectedLanguage() || "en"

  return x[lang] || x["en"] || {};
};
